// Shared team Google Calendar embed. Events are absolute; `ctz` only changes how the grid is
// labeled. We set it from the viewer's browser timezone so people outside Pacific see local hours.
import { useState } from "react";

const CAL_SRC =
  "c_2b4c5f562a26437bd1b120e1ef8cce6df9a5077b7edc7188588a4119b2682a31%40group.calendar.google.com";

/** Open the shared calendar in the viewer's Google Calendar (their account timezone applies there). */
export const TEAM_CALENDAR_OPEN =
  "https://calendar.google.com/calendar/u/0?cid=Y18yYjRjNWY1NjJhMjY0MzdiZDFiMTIwZTFlZjhjY2U2ZGY5YTUwNzdiN2VkYzcxODg1ODhhNDExOWIyNjgyYTMxQGdyb3VwLmNhbGVuZGFyLmdvb2dsZS5jb20";

const FALLBACK_TZ = "America/Los_Angeles";

function viewerTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || FALLBACK_TZ;
  } catch {
    return FALLBACK_TZ;
  }
}

function embedUrl(ctz: string): string {
  const params = new URLSearchParams({
    src: decodeURIComponent(CAL_SRC),
    mode: "WEEK",
    showTitle: "0",
    showNav: "1",
    showPrint: "0",
    showTabs: "0",
    showCalendars: "0",
    showTz: "1",
    ctz,
  });
  return `https://calendar.google.com/calendar/embed?${params.toString()}`;
}

/** Week-view embed; `ctz` follows the browser's local timezone (fallback: America/Los_Angeles). */
export function TeamCalendarIframe({ heightClass = "h-[520px]" }: { heightClass?: string }): JSX.Element {
  const [ctz] = useState(viewerTimeZone);
  return (
    <iframe
      src={embedUrl(ctz)}
      title="Team calendar"
      className={`block w-full border-0 bg-white ${heightClass}`}
    />
  );
}
